import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e355236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background":"#f6f6f6","padding":"14px 0 4px 8px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添 加")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("汇 率")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("提示")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 本期借方发生额,本期贷方发生额,两列点击可穿透交易记录 ")
const _hoisted_8 = ["onDblclick"]
const _hoisted_9 = ["onDblclick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("更多")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 编 辑 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 锁 定 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 解 锁 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 启 用 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 注 销 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("添加汇率")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("获取汇率")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")

  
const __default__ = {
  name: 'bankAccount'
}
import { ref, onBeforeMount, reactive, computed, ComputedRef } from 'vue'
import { useStore} from 'vuex'
import { useRouter } from 'vue-router'
import tbMix from '@/global_mixin/tableMixin'
import AccountBalance from '@/views/ViewsComponents/financial/AccountBalance.vue'
import AccountBill from '@/views/ViewsComponents/financial/AccountBill.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getNumber, deepClone, formatTime } from '@/utils/index'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
interface DropOptionItem {
  label: string;
  id: string;
}

interface DropOption {
  [prop: string]: DropOptionItem[];
  accountNumber: DropOptionItem[];
  accountName: DropOptionItem[];
  bankName: DropOptionItem[];
  company: DropOptionItem[];
  currency: DropOptionItem[];
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
    'POST/financial_banks/conditions': fetchList,
    // 添加银行账号
    'POST/financial_banks': financialBanksPost,
    // 编辑
    'PATCH/financial_banks': financialBanksPatch,
    // 银行账号删除
    'DELETE/financial_banks/{accountNumber}': delBanksAccountApi,
    // 锁定&&解锁
    'PATCH/financial_banks/status': banksStatusApi,
    // 获取汇率
    'POST/exchange_rates/conditions': exchangeRateApi,
    // 导出账号
    'POST/financial_banks/download': downloadApi,
    // 添加汇率
    'POST/exchange_rates': exchange_ratesApi,
    // 银行账户_标记删除(启动，注销)
    'PATCH/financial_banks/mark_deleted': financial_banksMark_deletedApi,
    // 汇率_手动更新
    'POST/exchange_rates/manual_sync': manual_syncApi,
} = Api

const router = useRouter()
const store = useStore()
let { 
    MI_height, MI_tableData, fetchData, page, size, MI_total, 
    MI_pageChange, MI_sizeChange, MI_identify, MI_modifyForm, MI_params 
} = new tbMix(fetchList)
const searchFormObject = reactive({
    accountNumber: '',
    accountName: '',
    companies: [],
    bankName: '',
    currency: '',
    deleted: false,
    displayZero: false,
    timgRange: [dayjs().startOf('year').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
    summary: '',
})

let dropObj: DropOption = reactive({
  // 账户ID
  "accountNumber": [],
  // 账户简称
  "accountName": [],
  // 银行简称
  "bankName": [],
  // 公司名称
  "company": [],
  // 币种
  "currency": [],
})
// 全部币种
let fullCurrency = ref<{label: string, id: string}[]>([])
onBeforeMount( () => {
    size.value = 200
    searchHandle(searchFormObject)

    getDropBoxHandle().then((rep: any) => {
        for (const key in rep) {
            dropObj[key] = [...rep[key]]
        }
        fullCurrency.value = deepClone(dropObj.currency)
    })
})


const defRules = [{ required: true, message: '必选项', trigger: 'change' }]
// 搜索参数特殊处理函数
const searchHandle = (params: any) => {
    let _params: any = {
        query: {
            ...params,
            collectionAt: {
                from: params.timgRange?.[0],
                to: params.timgRange?.[1],
            },
        }
    }
    fetchData(_params)
}

// 添加账号
let addTitle = ref('添加账号')
const addFg = ref<boolean>(false)
const addConfig  = ref<FromConfig[]>([
    {
        label: '账户ID',
        value: '',
        upKey: 'accountNumber',
        props: { disabled: false},
        rule: defRules
    },
    {
        label: '账户简称',
        value: '',
        upKey: 'accountName',
        rule: defRules
    },
    {
        label: '公司名称',
        value: '',
        upKey: 'company',
        rule: defRules,
    },
    {
        label: '银行摘要',
        value: '',
        upKey: 'summary'
    },
    {
        label: '银行名称',
        value: '',
        upKey: 'bankName',
        rule: defRules
    },
    {
        type: 'SELECT',
        label: '是否支持直连',
        value: '',
        upKey: 'payType',
        options: [
            { label: '支持', id: 0 },
            { label: '不支持', id: 1 },
        ],
        rule: defRules,
        placeholder: '请选择是否支持直连',
        seleProps: {
            label: 'label',
            valueName: 'id',
        }
    },
    {
        label: '账号',
        value: '',
        upKey: 'accountId',
        rule: defRules,
    },
    {
        label: '币种',
        value: '',
        upKey: 'currency',
        rule: defRules,
    },
    {
        type: 'NUMBER',
        label: '初始金额',
        value: '',
        upKey: 'initialAmount',
        rule: [
            { type: 'number', message: '请输入正确初始金额' },
            { required: true, message: '请输入初始金额', trigger: 'change' },
        ],
        props: { type: 'number'}
    },
    {
        label: '银行账号编码',
        value: '',
        upKey: 'bankAccountCode',
    },
    {
        label: '银行编码',
        value: '',
        upKey: 'bankCode',
    },
])
const addAccountHandle = async () => {
    addTitle.value = '添加账号'
    addConfig.value[0]['props' as FromConfig['']].disabled = false
    MI_modifyForm({}, addConfig, addFg, async (params: any) => {
        await financialBanksPost({...params, creatorId: store.state.userId})
        addFg.value = false
        ElMessage.success('添加成功')
    })
}

// 编辑
const isShowEdit = ref<boolean>(false)
const editConfig = ref([
  {
    label: '账户ID',
    value: '',
    upKey: 'accountNumber',
    props: { disabled: true},
  },
  {
    label: '账户简称',
    value: '',
    upKey: 'accountName',
    rule: defRules
  },
  {
    label: '公司名称',
    value: '',
    upKey: 'company',
    rule: defRules,
  },
  {
    label: '银行摘要',
    value: '',
    upKey: 'summary'
  },
  {
    label: '银行名称',
    value: '',
    upKey: 'bankName',
    rule: defRules
  },
  {
    type: 'SELECT',
    label: '是否支持直连',
    value: '',
    upKey: 'payType',
    options: [
        { label: '支持', id: 0 },
        { label: '不支持', id: 1 },
    ],
    rule: defRules,
    placeholder: '请选择是否支持直连',
    seleProps: {
        label: 'label',
        valueName: 'id',
    }
  },
  {
    label: '账号',
    value: '',
    upKey: 'accountId',
    rule: defRules,
  },
  {
    label: '币种',
    value: '',
    upKey: 'currency',
    rule: defRules,
  },
  {
    type: 'NUMBER',
    label: '初始金额',
    value: '',
    upKey: 'initialAmount',
    props: { type: 'number', disabled: true}
  },
  {
    label: '银行账号编码',
    value: '',
    upKey: 'bankAccountCode',
  },
  {
    label: '银行编码',
    value: '',
    upKey: 'bankCode',
  },
  {
    label: '创建时间', value: '', upKey: 'createdAt', props: { disabled: true}
  },
  {
    label: '创建人', value: '', upKey: 'creator', props: { disabled: true}
  },
  {
    label: '注销操作时间', value: '', upKey: 'deleteAt', props: { disabled: true}
  },
  {
    type: 'SELECT',
    label: '注销状态',
    value: '',
    upKey: 'deleted',
    options: [
      {label: '已注销', id: true},
      {label: '未注销', id: false},
    ],
    props: {disabled: true},
    seleProps: { label: 'label', valueName: 'id'},
  },
])
const editHandle = async (row: any) => {
  MI_modifyForm(row, editConfig, isShowEdit, async (params: any) => {
    await financialBanksPatch({...params, creatorId: store.state.userId})
    isShowEdit.value = false
    ElMessage.success('编辑成功')
    fetchData(MI_params)
  })
}

// 行删除
const deleteRow = async (row: any) => {
    await ElMessageBox.confirm(
        '确认删除',
        '警告',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
    await delBanksAccountApi({accountNumber: row.accountNumber})
    ElMessage.success('删除成功')
    fetchData(MI_params)
}

// 注销/启用
const writeOff = async (row: any) => {
    MI_identify.value = true
    console.log(row);
    
    try {
        await financial_banksMark_deletedApi({deleted: !row.deleted, id: row.accountNumber}, {contentType: 'formData'})
        MI_identify.value = false
        ElMessage.success('成功')
        fetchData(MI_params)
    } catch (error) {
        MI_params.value = false
    }
}


// 锁定
const lockFg = ref<boolean>(false)
const lockConfig = ref<FromConfig[]>([
    {
        type: "TIME",
        label: "锁定日期",
        value: '',
        upKey: 'to',
        rule: [{ required: true, message: '必选项', trigger: 'change' }],
        props: {
            'value-format': 'YYYY-MM-DD',// 日期格式 （到天）
            'disabled-date': function(time: any){
                return time.getTime() > Date.now()
            }
        }
    },
])
const lockHandle =  (row: any) => {
    
    if(row.locked === 0) {
        // 没有锁定
        lockConfig.value[0].props = {
            'value-format': 'YYYY-MM-DD',
            'disabled-date': function(time: any){
                return time.getTime() > Date.now()
            }
        }

    } else {
        let lockTimeStamp = (new Date(row.lockTo)).getTime()
        lockConfig.value[0].props = {
            'value-format': 'YYYY-MM-DD',
            'disabled-date': function(time: any){
                return time.getTime() > Date.now() || time.getTime() < lockTimeStamp
            }
        }

    }
    MI_modifyForm({}, lockConfig, lockFg, async (params: any) => {
        await banksStatusApi({
            accountNumber: row.accountNumber,
            creatorId: store.state.userId,
            locked: '1',
            lockAt: { to: params.to }
        })
        ElMessage.success('锁定成功')
        lockFg.value = false
        fetchData(MI_params)
    })
    /*  
        await banksStatusApi({
            accountNumber: row.accountNumber,
            creatorId: store.state.userId,
            locked: '1',
            lockAt: { to: params.to }
        })
        ElMessage.success('锁定成功')
        lockFg.value = false
        fetchData(MI_params)
    */
    

}
// 解锁
const unLockFg = ref<boolean>(false)
const unLockConfig = ref<FromConfig[]>([
    {
        type: "TIME",
        label: "解锁日期",
        value: '',
        upKey: 'from',
        rule: [ { required: true, message: '必选项', trigger: 'change' } ],
        props: { }
    },
])
let unlockTips = ref<string>('')
const unlockHandle = (row: any) => {
    
    if(row.locked === 1){
        unLockConfig.value[0].value = row.lockTo
        // 锁定状态
        unlockTips.value = row.lockTo
    } else {
        unLockConfig.value[0].value = ''
        unlockTips.value = '未锁定'
    }

    unLockConfig.value[0].props = {
        'value-format': 'YYYY-MM-DD',
        'disabled-date': function(time: any){
            return time.getTime() > dayjs(row.lockTo).format('x')
        },
        'default-value': new Date(row.lockTo || Date.now())
    }
    
    MI_modifyForm({}, unLockConfig, unLockFg,  async (params: any) => {
        await banksStatusApi({
            accountNumber: row.accountNumber,
            creatorId: store.state.userId,
            locked: '0',
            lockAt: {
                from: params.from,
                to: row.lockTo
            }
        })
        ElMessage.success('解锁成功')
        unLockFg.value = false
        fetchData(MI_params)
    })
        
    /* await banksStatusApi({
        accountNumber: row.accountNumber,
        creatorId: store.state.userId,
        locked: '0',
        lockAt: {
            from: params.from,
            to: row.lockTo
        }
    })
    ElMessage.success('解锁成功')
    fetchData(MI_params)
    unLockFg.value = false */
    
}

// 展示汇率
let { 
    MI_tableData: erData,  fetchData: erFetchData, page: erPage, size: erSize, 
    MI_total: erTotal, MI_pageChange: erPageChange, MI_sizeChange: erSizeChange, MI_identify: erIdentify, 
} = new tbMix(exchangeRateApi)
const exchangeRateEle: any = ref(null)
const exchangeRateFg = ref<boolean>(false)
const exchangeRateForm = reactive({
    original: '',
    target: '',
    collectAt: [],
    createAt: [],

})
const showexchangeRate = () => {
    exchangeRateFg.value = true
    setTimeout(exchangeSearchHandle, 0)
}
const exchangeSearchHandle = () => {
    exchangeRateEle.value.validate((valid: boolean) => {
        if (!valid) return;
        erFetchData({
            query: {
                original: exchangeRateForm.original,
                target: exchangeRateForm.target,
                collectAt: {
                    from: exchangeRateForm.collectAt[0],
                    to: exchangeRateForm.collectAt[1],
                },
                createAt: {
                    from: exchangeRateForm.createAt[0],
                    to: exchangeRateForm.createAt[1],
                },
            }
        })
        
    })
}

// 添加汇率
const showAddRate = ref<boolean>(false)
const addRateConfig = ref([
    {
        type: 'SELECT',
        label: '原始币种',
        value: '',
        upKey: 'original',
        options: fullCurrency,
        props: { placeholder: '请选择原始币种', clearable: true},
        rule: [{ required: true, message: '请选择原始币种', trigger: 'change' }],
        seleProps: { label: 'label', valueName: 'id' },
    },
    {
        type: 'SELECT',
        label: '目标币种',
        value: '',
        upKey: 'target',
        options: fullCurrency,
        props: { placeholder: '请选择目标币种', clearable: true},
        rule: [{ required: true, message: '请选择目标币种', trigger: 'change' }],
        seleProps: { label: 'label', valueName: 'id' },
    },
    {
        type: 'NUMBER',
        label: '汇率',
        value: 0,
        upKey: 'medianPrice',
        props: { precision: 10},
        rule: [{ required: true, message: '请输入汇率', trigger: 'change' }],
    },
    {
        type: "TIME",
        label: "收集日期",
        value: '',
        upKey: 'collectAt',
        rule: [{ required: true, message: '请选择日期', trigger: 'change' }],
        props: { 'value-format': 'YYYY-MM-DD' }
    },
])
const addRateHandle = () => {
    MI_modifyForm({}, addRateConfig, showAddRate, async (params: object) => {
        await exchange_ratesApi(params)
        ElMessage.success('成功')
        showAddRate.value = false
        exchangeSearchHandle()
    })
}

// 获取汇率
const isShowExchange = ref<boolean>(false)
const isSubmitLoading = ref<boolean>(false)
let exchangeRang: any = ref([])
const submitExchange = () => {
  if(exchangeRang.value.length === 0){
    ElMessage.warning('请选择日期范围')
    return
  }
  isSubmitLoading.value = true
  manual_syncApi({
    startDate: exchangeRang.value[0],
    endDate: exchangeRang.value[1],
  }).then(() => {
    ElMessage.success('成功')
    isShowExchange.value = false
    exchangeRang.value = []
  }).finally(() => {
    isSubmitLoading.value = false
  })
}

// --表格高度--
const collapseNames = ref('')
const fixedHeight: ComputedRef<number> = computed(() =>{
    if(collapseNames.value === '1'){
        return MI_height - 280
    }
    return MI_height - 70

})

// ---金额格式化---
const formatHandle =  (row: any, column: any, cellValue: any, index: any) => {
  return getNumber(cellValue)
}
const tableJumpHandle = (row: any) => {
    router.push({
        path: '/bank-flow',
        query: {
            accountNumber: row.accountNumber,
            bankName: row.bankName,
            company: row.costFrom,
            accountName: [row.accountName],
            currency: row.currency,
        }
    })
}

// 合计 
const flowSummaries = (param: any) => {
  const { columns, data } = param
  return columns.reduce((arr: string[], column: any, index: number) => {
    if(![3, 4, 5, 6, 7, 8].includes(index)) return arr;
    const values = data.map((item: any) => Number(item[column.property]))
    const totalNumb = values.reduce((prev: number, curr: number) => {
      const value = Number(curr)
      if (!Number.isNaN(value)) {
        return prev + curr
      } else {
        return prev
      }
    }, 0)
    arr[index] = getNumber(totalNumb)
    return arr
  }, ['合计'])
}

// 导出参数
const exportParams = computed(() => {
  return MI_params.query
})

const rowClass = ({row, rowIndex}: any) => {
  if(row.deleted === true){
    return 'grayRow'
  }
}



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "银行账号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, {
              modelValue: collapseNames.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((collapseNames).value = $event)),
              accordion: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, {
                  title: "银行账号",
                  name: "1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_el_form, {
                        "label-position": "left",
                        model: _unref(searchFormObject),
                        inline: true,
                        ref: "searchElement",
                        "label-width": "100",
                        disabled: _unref(MI_identify)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "账户ID",
                            prop: "accountNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "form-input",
                                filterable: "",
                                modelValue: _unref(searchFormObject).accountNumber,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchFormObject).accountNumber) = $event)),
                                placeholder: "请选择账户ID",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).accountNumber, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      key: item.id,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "账户简称",
                            prop: "accountName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "form-input",
                                filterable: "",
                                modelValue: _unref(searchFormObject).accountName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchFormObject).accountName) = $event)),
                                placeholder: "请选择账户简称",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).accountName, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      key: item.id,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "银行名称",
                            prop: "bankName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "form-input",
                                filterable: "",
                                modelValue: _unref(searchFormObject).bankName,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchFormObject).bankName) = $event)),
                                placeholder: "请选择银行名称",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).bankName, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      key: item.id,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "币种",
                            prop: "currency"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "form-input",
                                filterable: "",
                                modelValue: _unref(searchFormObject).currency,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchFormObject).currency) = $event)),
                                placeholder: "请选择币种",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).currency, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      key: item.id,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "摘要",
                            prop: "summary"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                placeholder: "请输入摘要",
                                class: "form-input",
                                clearable: "",
                                modelValue: _unref(searchFormObject).summary,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchFormObject).summary) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "注销状态",
                            prop: "deleted"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "form-input",
                                modelValue: _unref(searchFormObject).deleted,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchFormObject).deleted) = $event)),
                                placeholder: "请选择注销状态",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "全部",
                                    value: ""
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "已注销",
                                    value: true
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "未注销",
                                    value: false
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "公司名称",
                            prop: "companies"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                multiple: "",
                                "collapse-tags": "",
                                style: {"width":"330px"},
                                class: "form-input",
                                filterable: "",
                                modelValue: _unref(searchFormObject).companies,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchFormObject).companies) = $event)),
                                placeholder: "请选择公司名称",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).company, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      key: item.id,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "为零显示",
                            prop: "displayZero"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "form-input",
                                filterable: "",
                                modelValue: _unref(searchFormObject).displayZero,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchFormObject).displayZero) = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "显示",
                                    value: true
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "不显示",
                                    value: false
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "交易日期",
                            prop: "timgRange"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _unref(searchFormObject).timgRange,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchFormObject).timgRange) = $event)),
                                type: "daterange",
                                "disabled-date": (time) => time.getTime() > Date.now(),
                                "value-format": "YYYY-MM-DD",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                placeholder: "请选择交易日期"
                              }, null, 8, ["modelValue", "disabled-date"])
                            ]),
                            _: 1
                          }),
                          _hoisted_2,
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (searchHandle(_unref(searchFormObject))))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "disabled"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (addAccountHandle())),
              class: "mt-10 mb-10",
              type: "primary",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["disabled"])), [
              [_directive_permission, 'Create']
            ]),
            _createVNode(_component_el_button, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (showexchangeRate())),
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_eptBtn, {
              exportFn: _unref(downloadApi),
              exportText: '导出账号',
              exportParam: _unref(exportParams)
            }, null, 8, ["exportFn", "exportParam"]),
            _createVNode(_component_el_popover, {
              placement: "bottom",
              width: 400,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "ml-10",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: "",
              "max-height": _unref(fixedHeight) + 'px',
              data: _unref(MI_tableData),
              "show-summary": "",
              "row-class-name": rowClass,
              "summary-method": flowSummaries
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "账户ID",
                  prop: "accountNumber",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "账户简称",
                  prop: "accountName",
                  width: "150",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency"
                }),
                _createVNode(_component_el_table_column, {
                  label: "期初余额",
                  prop: "startingAmount",
                  width: "125",
                  align: "right",
                  formatter: formatHandle,
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "本期贷方发生额",
                  prop: "ci",
                  width: "150",
                  align: "right",
                  formatter: formatHandle,
                  sortable: ""
                }, {
                  default: _withCtx(({row}) => [
                    _createElementVNode("p", {
                      style: {"cursor":"pointer"},
                      onDblclick: ($event: any) => (tableJumpHandle(row))
                    }, _toDisplayString(formatHandle(null, null, row.ci, null)), 41, _hoisted_8)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "本期借方发生额",
                  prop: "co",
                  width: "150",
                  align: "right",
                  formatter: formatHandle,
                  sortable: ""
                }, {
                  default: _withCtx(({row}) => [
                    _createElementVNode("p", {
                      style: {"cursor":"pointer"},
                      onDblclick: ($event: any) => (tableJumpHandle(row))
                    }, _toDisplayString(formatHandle(null, null, row.co, null)), 41, _hoisted_9)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "期末余额",
                  prop: "endingAmount",
                  width: "120",
                  align: "right",
                  formatter: formatHandle,
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "实时余额",
                  prop: "accountBalance",
                  width: "130",
                  align: "right",
                  formatter: formatHandle,
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "期末本位币余额",
                  prop: "endingCurrencyAmount",
                  width: "150",
                  align: "right",
                  formatter: formatHandle,
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "公司名称",
                  prop: "company",
                  width: "180",
                  "show-overflow-tooltip": "",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "银行名称",
                  prop: "bankName",
                  width: "200",
                  "show-overflow-tooltip": "",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "账号",
                  prop: "accountId",
                  width: "200",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "银行账号编码",
                  prop: "bankAccountCode",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "银行编码",
                  prop: "bankCode",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_popover, {
                      placement: "left",
                      width: 235,
                      trigger: "click"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_link, null, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (editHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          onClick: ($event: any) => (lockHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          onClick: ($event: any) => (unlockHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Write']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (deleteRow(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Delete']
                        ]),
                        (row.deleted)
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              type: "primary",
                              onClick: ($event: any) => (writeOff(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_permission, 'Write']
                            ])
                          : _createCommentVNode("", true),
                        (!row.deleted)
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                              key: 1,
                              type: "danger",
                              onClick: ($event: any) => (writeOff(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_permission, 'Delete']
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["max-height", "data"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              total: _unref(MI_total),
              "page-size": _unref(size),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
              class: "mt-10",
              disabled: _unref(MI_identify),
              "page-sizes": [30, 100, 200, 500],
              layout: "sizes, prev, pager, next, total",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "账户余额",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(AccountBalance)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "对账单",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(AccountBill)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: _unref(addTitle),
      draggable: "",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: addConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑账号",
      draggable: "",
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isShowEdit).value = $event))
    }, {
      default: _withCtx(() => [
        (isShowEdit.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
              searchConfig: editConfig.value,
              submitText: '确定'
            })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "锁定",
      width: "450px",
      modelValue: lockFg.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((lockFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        (lockFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: lockConfig.value,
                    isLeft: true,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "解锁",
      width: "500px",
      modelValue: unLockFg.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((unLockFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: '锁定时间: ' + _unref(unlockTips),
          type: "warning",
          closable: false,
          effect: "dark"
        }, null, 8, ["title"]),
        (unLockFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: unLockConfig.value,
                    isLeft: true,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: exchangeRateFg.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((exchangeRateFg).value = $event)),
      top: "50px",
      width: "70%",
      title: "汇率",
      onClose: _cache[26] || (_cache[26] = ($event: any) => (exchangeRateEle.value.resetFields()))
    }, {
      default: _withCtx(() => [
        (exchangeRateFg.value)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _unref(exchangeRateForm),
              inline: true,
              ref_key: "exchangeRateEle",
              ref: exchangeRateEle
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "原始货币",
                  prop: "original"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(exchangeRateForm).original,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(exchangeRateForm).original) = $event)),
                      placeholder: "请选择原始货币",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullCurrency), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            key: item.id,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "目标货币",
                  prop: "target"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(exchangeRateForm).target,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(exchangeRateForm).target) = $event)),
                      placeholder: "请选择目标货币",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullCurrency), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            key: item.id,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "时间",
                  prop: "collectAt"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(exchangeRateForm).collectAt,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(exchangeRateForm).collectAt) = $event)),
                      "value-format": "YYYY-MM-DD",
                      "disabled-date": (time) => { return time.getTime() > Date.now()},
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "创建时间",
                  prop: "createAt"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(exchangeRateForm).createAt,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(exchangeRateForm).createAt) = $event)),
                      "value-format": "YYYY-MM-DD",
                      "disabled-date": (time) => { return time.getTime() > Date.now()},
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (exchangeSearchHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: addRateHandle }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[23] || (_cache[23] = ($event: any) => (isShowExchange.value = true))
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "mt-10",
          border: "",
          data: _unref(erData),
          "max-height": "600"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "原始货币",
              prop: "original"
            }),
            _createVNode(_component_el_table_column, {
              label: "目标货币",
              prop: "target"
            }),
            _createVNode(_component_el_table_column, {
              label: "买入",
              prop: "purchasePrice"
            }),
            _createVNode(_component_el_table_column, {
              label: "中间价格",
              prop: "medianPrice"
            }),
            _createVNode(_component_el_table_column, {
              label: "卖出",
              prop: "sellingPrice"
            }),
            _createVNode(_component_el_table_column, {
              label: "中行折算价",
              prop: "bocConvertPrice"
            }),
            _createVNode(_component_el_table_column, {
              label: "汇率日期",
              prop: "collectAt"
            }),
            _createVNode(_component_el_table_column, {
              label: "创建日期",
              prop: "createAt",
              formatter: _unref(formatTime)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(erIdentify)]
        ]),
        _createVNode(_component_el_pagination, {
          small: "",
          style: {"float":"none"},
          total: _unref(erTotal),
          "page-size": _unref(erSize),
          currentPage: _unref(erPage),
          "onUpdate:currentPage": _cache[24] || (_cache[24] = ($event: any) => (_isRef(erPage) ? (erPage).value = $event : erPage = $event)),
          class: "mt-10",
          "page-sizes": [10, 30, 50, 100],
          layout: "sizes, prev, pager, next, total",
          onCurrentChange: _unref(erPageChange),
          onSizeChange: _unref(erSizeChange)
        }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showAddRate.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((showAddRate).value = $event)),
      title: "添加汇率"
    }, {
      default: _withCtx(() => [
        (showAddRate.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: addRateConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowExchange.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((isShowExchange).value = $event)),
      title: "获取汇率",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: isSubmitLoading.value,
          onClick: _cache[29] || (_cache[29] = ($event: any) => (isShowExchange.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          loading: isSubmitLoading.value,
          type: "primary",
          onClick: _cache[30] || (_cache[30] = ($event: any) => (submitExchange()))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: _unref(exchangeRang),
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_isRef(exchangeRang) ? (exchangeRang).value = $event : exchangeRang = $event)),
          clearable: false,
          type: "daterange",
          "range-separator": "至",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})